// Events plugin.
import * as actionTypes from './actionTypes'

// Libraries.
import { update, add, concat, contains } from 'lodash/fp'

function eventReducer (state = { aliases: [], count: 0 }, action) {
  switch (action.type) {
    case actionTypes.EVENTS_ON:
      return update('count', add(1), state)
    case actionTypes.EVENTS_OFF:
      return update('count', add(-1), state)
    case actionTypes.EVENTS_ALIAS:
      return update('aliases', concat(action.payload.alias), state)
    default:
      return state
  }
}

/**
 * Reducer for Event Emitter plugin.
 * Defines the events an Event plugin should dispatch to modify state.
 * @param  {Object} [state={}] The events substate.
 * @param  {Object} action     A Flux Standard action.
 * @returns {Object} state      The new event substate.
 */
export default function reducer (state = {}, action) {
  // Only handle event types.
  if (!contains(action.type, actionTypes)) {
    return state
  }

  return {
    ...state,
    [action.payload.eventType]: eventReducer(state[action.payload.eventType], action)
  }
}
